import React from 'react';
import { Button } from '@/components/app/ui/button';
import signInWithGoogle from '@/components/auth/signInWithGoogle';
import CodeDisplay, { CodeDisplaySimple } from '@/components/ui/CodeDisplay';
import BentoFeatures from '@/components/v4/BentoFeatures';
import { calLink } from '@/utils/constants';
import { Menu } from '@headlessui/react';
import { MendableChatBubble, MendableInPlace } from '@mendable/search';
import Link from 'next/link';
export default function CTAButtons() {
  return (
    <div
      className="sm:max-w-none flex items-center justify-start  space-y-0 !space-x-3 "
      data-aos="zoom-out"
      data-aos-delay="300"
    >
      <div>
      <Link href="/signup">
        <Button
          className="btn text-lg text-white bg-mendable-500 hover:bg-opacity-75 w-full transition duration-150 ease-in-out group"
        >
          Get Started
        </Button>
        </Link>
      </div>
      <div>
        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button className="btn text-lg text-white bg-gray-800 hover:bg-opacity-75 border border-primary w-full transition duration-150 ease-in-out group">
            Talk to Us
          </Menu.Button>
          <Menu.Items className="origin-top-right absolute right-0 mt-2 w-32 rounded-md shadow-lg bg-black ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1">
              <Menu.Item>
                {({ active }) => (
                  <a
                    href="mailto:eric@mendable.ai"
                    className={`${
                      active ? 'bg-gray-700 text-white' : 'text-white'
                    } block px-4 py-2 text-sm`}
                  >
                    Email Us
                  </a>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <a
                    href={calLink}
                    onClick={() => {
                      window.location.href = calLink;
                    }}
                    className={`${
                      active ? 'bg-gray-700 text-white' : 'text-white'
                    } block px-4 py-2 text-sm`}
                  >
                    Book Meeting
                  </a>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Menu>
      </div>
    </div>
  );
}
